import axios from 'axios';

export const STALE_TIME = 1000 * 60 * 10; // react-query global staleTime

export const leaderboardAxios = axios.create({
  withCredentials: false,
});

// TODO RQ consolidate api logic etc
